import CampaignsListItem from './CampaignsListItem';

// @vue/component
export default {
  name: 'CampaignsList',

  components: {
    CampaignsListItem,
  },

  computed: {
    campaignsList() {
      return this.$store.getters['campaigns/list'];
    },
  },

  created() {
    this.$store.dispatch('campaigns/getList');
  },

  methods: {
    handleChangePage(page) {
      this.$store.dispatch('campaigns/changePage', page);
    },
    handleGoToHelp() {
      this.$router.push({ name: 'PlatformHelp' });
    }
  },
};
